import React from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { setSelectedTab } from "../../reducers/wip.reducer";

const WIPTabs = () => {
  const dispatch = useDispatch();
  const selectedTab = useSelector((state) => state.wip?.selectedTab || "batch");

  const handleChange = (event, newValue) => {
    dispatch(setSelectedTab(newValue));
  };

  const tabs = [
    { value: "batch", label: "WIP Report wise view" },
    { value: "wipActionNeeded", label: "WIP Action Needed" },
    // { value: 'wipData', label: 'WIP Data' },
    // { value: 'analytics', label: 'Analytics' },
  ];

  return (
    <Box sx={{ width: "100%", px: 2, flexGrow: 1 }}>
      <Tabs
        variant="fullWidth"
        value={selectedTab}
        onChange={handleChange}
        sx={{ textDecoration: "none" }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            value={tab.value}
            label={tab.label}
            sx={{ textTransform: "none" }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default WIPTabs;
